import React from "react";
import "../Terms&Conditions/TermsAndConditions.css";

export const ShippingDeliveryPolicy = () => {
  return (
    <div className="container">
      <div className="termsHeader mt-3">
        <h2>Shipping & Delivery Policy </h2>
        <p>
          <b> Effective Date: 1-Oct-2025 </b>
        </p>
      </div>
      <div className="termsContainer">
        <div className="terms-list-content">
          <div className="list-header">Digital Delivery </div>
          <div className="terms-content">
            <p>
              All services, training, and certifications are delivered digitally
              via email, WhatsApp, or online platforms.{" "}
            </p>
            <p>
              Access is generally provided within 24 hours of payment
              confirmation.{" "}
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Physical Delivery</div>
          <div className="terms-content">
            <p>We do not ship physical goods unless specifically mentioned. </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Technical Delays </div>
          <div className="terms-content">
            <p>
              In rare cases, access may be delayed due to technical issues. We
              commit to resolving promptly.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
